import React from 'react';

import styled from 'styled-components';

import useBuilderConstructorGridInputs from '../hooks/useBuilderConstructorGridInputs';

import DesktopGridSortDropdown from './DesktopGridSortDropdown';
import DesktopSideNavBreadcrumbs from './DesktopSideNav/DesktopSideNavBreadcrumbs';

const HeaderWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 20px 32px 0 32px;
  margin-top: 32px;
  margin-bottom: 24px;
  justify-content: space-between;
  align-items: center;
`;

// This wrapper is used to align the breadcrumbs and the title
const DesktopSideNavBreadCrumbsWrapper = styled.div`
  margin-right: 2rem;
  flex: 0 0 268px;
`;

const HeaderTitle = styled.h1`
  font-weight: bold;
  font-size: 1.5rem;
  width: 100%;
`;

const DesktopGridHeader = () => {
  const { gridHeader } = useBuilderConstructorGridInputs();

  return (
    <HeaderWrapper>
      <DesktopSideNavBreadCrumbsWrapper>
        <DesktopSideNavBreadcrumbs />
      </DesktopSideNavBreadCrumbsWrapper>
      <HeaderTitle>{gridHeader}</HeaderTitle>
      <DesktopGridSortDropdown />
    </HeaderWrapper>
  );
};

export default DesktopGridHeader;
